import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress, 
  IconButton, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemText, 
  Paper,
  Radio 
} from '@mui/material';
import { Refresh } from '@mui/icons-material';
import metaService from '../../../../services/metaService';

const MetaFormSelector = ({ authData, selectedPages, onFormsSelected }) => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedForm, setSelectedForm] = useState('');

  const fetchForms = async () => {
    if (selectedPages.length > 0) {
      setLoading(true);
      try {
        const pageId = selectedPages[0].id; // Assuming the first selected page
        const tokenKey = selectedPages[0].tokenKey;
        const response = await metaService.getPageLeadgenForms(pageId, tokenKey);
        // console.log('Formulários buscados com sucesso:', response);
        if (response.success) {
          setForms(response.data.forms);
        }
      } catch (error) {
        console.error('Erro ao buscar formulários:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    // console.log('Páginas selecionadas alteradas:', selectedPages, authData);
    fetchForms();
  }, [selectedPages, authData]);

  const handleFormSelection = (form) => {
    setSelectedForm(form.id);
    onFormsSelected([form]);
  };

  const handleReload = () => {
    setSelectedForm('');
    onFormsSelected([]);
    fetchForms();
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h5">
          Selecionar Formulário Lead Instantâneo
        </Typography>
        <IconButton 
          onClick={handleReload} 
          disabled={loading || selectedPages.length === 0}
          title="Recarregar formulários"
        >
          <Refresh />
        </IconButton>
      </Box>
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper variant="outlined" sx={{ maxHeight: 400, overflow: 'auto' }}>
          <List>
            {forms.map((form) => (
              <ListItem key={form.id} disablePadding>
                <ListItemButton 
                  onClick={() => handleFormSelection({id: form.id, name: form.name})}
                  selected={selectedForm === form.id}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(25, 118, 210, 0.1)',
                      '&:hover': {
                        backgroundColor: 'rgba(25, 118, 210, 0.2)',
                      },
                    },
                    '&:hover': {
                      backgroundColor: 'rgba(25, 118, 210, 0.1)',
                    },
                  }}
                >
                  <Radio
                    edge="start"
                    checked={selectedForm === form.id}
                    tabIndex={-1}
                    disableRipple
                    sx={{ mr: 1 }}
                  />
                  <ListItemText 
                    primary={form.name}
                    secondary={`ID: ${form.id}`}
                    primaryTypographyProps={{ fontWeight: 'medium' }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
      
      {forms.length === 0 && !loading && selectedPages.length > 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', p: 3 }}>
          Nenhum formulário encontrado
        </Typography>
      )}
    </Box>
  );
};

export default MetaFormSelector;